



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Attachment } from '@/modules/tickets/incidents/shared/domain/attachment';
import { PropSync, Watch } from 'vue-property-decorator';

@Component({
    name: 'attachment-zone',
})
export default class AttachmentZone extends Vue {
    @PropSync('selectedFile', { required: true })
    file!: Attachment;

    files: Attachment[] = [];

    $refs!: {
        upload: any;
    };

    removeFile(id: string) {
        this.$refs.upload.remove(id);
    }

    @Watch('files')
    onFilesChanged(value: Attachment[]) {
        if (value && value.length) {
            this.file = value[0].file;
        }
    }
}
